import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AccountStateQuery, AccountStateStore } from './state';

@Injectable({
  providedIn: 'root',
})
export class AccountStorage {
  private readonly store: AccountStateStore = inject(AccountStateStore);
  private readonly query: AccountStateQuery = inject(AccountStateQuery);
  private idTimeout?: number;
  public readonly notificationDuration: number = 72 * 3600 * 1000; // 72 hours

  public constructor() {
    this.init();
  }

  public hasEmailChangeNotification(): Observable<boolean> {
    return this.query.select('emailChangeNotificationExpiration').pipe(
      map((value?: number) => Boolean(value)),
    );
  }

  public setEmailChangeNotification(): void {
    this.store.update({
      emailChangeNotificationExpiration: Date.now() + this.notificationDuration,
    });

    this.updateResetTimer(this.notificationDuration);
  }

  public hasAccountDeleteNotification(): Observable<boolean> {
    return this.query.select('accountDeleteNotificationExpiration').pipe(
      map((value?: number) => Boolean(value)),
    );
  }

  public setAccountDeleteNotification(): void {
    this.store.update({
      accountDeleteNotificationExpiration: Date.now() + this.notificationDuration,
    });

    this.updateResetTimer(this.notificationDuration);
  }

  private init(): void {
    const notificationExpiration: number | undefined = this.store.getValue()?.emailChangeNotificationExpiration;

    if (notificationExpiration) {
      this.updateResetTimer(notificationExpiration - Date.now());
    }
  }

  private updateResetTimer(timeout: number): void {
    if (this.idTimeout) {
      window.clearTimeout(this.idTimeout);
    }

    this.idTimeout = window.setTimeout(
      () => void this.store.reset(),
      Math.max(timeout, 0),
    );
  }
}
